<style scoped>
  .call-status {
    margin: 0.3rem 0;
  }
</style>

<template>
  <div>
    <p class="call-status">
      {{ __('Ligação para') }} <strong>{{ phone }}</strong>: {{ activity.call_status }}.
    </p>

    <audio
      controls
      type="audio/wav"
      :src="activity.data.audioLink"
      v-if="activity.data.audioLink"
    >
      <p>
        <a
          target="_blank"
          :href="activity.data.audioLink"
        >{{ __('Clique aqui') }}</a> {{ __('para ouvir') }}.
      </p>
    </audio>
  </div>
</template>

<script>
export default {
  props: ['activity'],

  data () {
    return {};
  },

  computed: {
    phone () {
      const phone = this.activity.data.called || '';

      return this.format(phone.slice(0, 2), phone.slice(2, -4), phone.slice(-4));
    },
  },

  methods: {
    format (code, prefix, extension) {
      return `(${code}) ${prefix}-${extension}`;
    },
  },
};
</script>
